<template>
    <div class="sales-card-video-modal">
       <div class="video-player" v-if="videoData != null">
            <iframe :src="videoData.link + '?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&autoplay=1'" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
        </div>
       <a href="#" class="close-link" @click.prevent="closeVideoModal"><svgIcon name="close" class="icon-svg"/></a>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'sales-card-about',
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            videoData: 'loadSalesCardVideoModalData',
        }),
        methods: {
            closeVideoModal() {
                this.$store.commit('setOpenSalesCardVideoModal', false);
                this.$store.commit('setSalesCardVideoModalData', null);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                document.getElementById('header').classList.remove('visibilityHide');
                document.getElementById('footer').classList.remove('visibilityHide');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-card/sales-card-video-modal.scss';
    // @import '@/styles/components/sales-card/respond/sales-card-about-respond.scss';
</style>